import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty, cloneDeep } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import { uploadMultiPartFiles, saveOutputTemplateByType, getOutputTemplateByType } from '../../../App/actions';
import { ItemServicesSearchForm, ItemCustomerServicesSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  AccountHeaderFrom,
  TitleFrom,
  ModalWithItem,
  DragDropConfigExportTemplate,
} from '../../../../components/common';
import { tabelColumnExportItemServices, sortItemServices } from '../../constants';
import { getBillableServicesReport, getAllBillableServicesReport } from '../../actions';
import { makeGetListBillableServices, makeGetListAllBillableServices } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelItemServices';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfItemServices';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class ItemServices extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listItemServices: [],
    exportColumnsSave: null,
    idOutputTemplate: null,
    typeOutputTemplate: null,
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listItemServices: props.listItemServices,
      totalCount: getPageTotalCount({ ...state, items: props.listItemServices }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetBillableService },
    } = this.props;
    if (modeGetBillableService) {
      this.doGetListItemServices();
      this.doGetOutputTemplateByType();
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListItemServices();
    });
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doGetListItemServices());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListItemServices());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListItemServices();
    });
  };

  doGetListItemServices = () => {
    const { filter, page, size, sorted } = this.state;
    const { getBillableServicesReport, accountDetail, dataContact, isFromCustomer, id } = this.props;
    const sNomComercial =
      accountDetail?.customAttributes && accountDetail.customAttributes.length
        ? accountDetail.customAttributes.find(val => val.name.toLocaleLowerCase() === 's_nom_comercial')
        : null;
    const newFilter = cloneDeep(filter);
    if (dataContact && isFromCustomer) {
      if (accountDetail.type === 'CLIENT' && sNomComercial) {
        newFilter.commercialName = sNomComercial?.value ? sNomComercial.value : '';
      } else {
        newFilter.accountId = id;
      }
    }
    // if (!newFilter.accounttype) newFilter.accounttype = 'DIRECT_CUSTOMER';
    if (newFilter.delivered) newFilter.delivered = newFilter.delivered === 'TRUE' ? 'true' : 'false';
    if (newFilter.invoiceExhibits) newFilter.invoiceExhibits = newFilter.invoiceExhibits === 'TRUE' ? 'true' : 'false';
    if (newFilter.childServices) newFilter.childServices = newFilter.childServices === 'TRUE' ? 'true' : 'false';
    if (newFilter.billed) newFilter.billed = newFilter.billed === 'TRUE' ? 'true' : 'false';
    const payload = {
      page: page + 1,
      size,
      filter: newFilter,
      sort:
        !isEmpty(sorted) && sortItemServices[sorted.sortCol] ? sortItemServices[sorted.sortCol][sorted.sortDir] : null,
    };
    this.setState({ isSearching: true });
    getBillableServicesReport(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistItemServices = cb => {
    const { filter, sorted } = this.state;
    const { getAllBillableServicesReport, accountDetail, dataContact, isFromCustomer, id } = this.props;
    const sNomComercial =
      accountDetail?.customAttributes && accountDetail.customAttributes.length
        ? accountDetail.customAttributes.find(val => val.name.toLocaleLowerCase() === 's_nom_comercial')
        : null;
    const newFilter = cloneDeep(filter);
    if (dataContact && isFromCustomer) {
      if (accountDetail.type === 'CLIENT' && sNomComercial) {
        newFilter.commercialName = sNomComercial?.value ? sNomComercial.value : '';
      } else {
        newFilter.accountId = id;
      }
    }
    // if (!newFilter.accounttype) newFilter.accounttype = 'DIRECT_CUSTOMER';
    if (newFilter.delivered) newFilter.delivered = newFilter.delivered === 'TRUE' ? 'true' : 'false';
    if (newFilter.invoiceExhibits) newFilter.invoiceExhibits = newFilter.invoiceExhibits === 'TRUE' ? 'true' : 'false';
    if (newFilter.childServices) newFilter.childServices = newFilter.childServices === 'TRUE' ? 'true' : 'false';
    if (newFilter.billed) newFilter.billed = newFilter.billed === 'TRUE' ? 'true' : 'false';
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter: newFilter,
      sort: !isEmpty(sorted) ? sortItemServices[sorted.sortCol][sorted.sortDir] : null,
    };
    getAllBillableServicesReport(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistItemServices(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllItemServices, t } = this.props;
        convertJson2Pdf({
          data: listAllItemServices,
          t,
          title: t('reportPage:sidebar.subscriptionBillableServices').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.subscriptionBillableServices')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistItemServices(() => {
      const { listAllItemServices, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'BILLABLE_SERVICES_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.subscriptionBillableServices')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.subscriptionBillableServices')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllItemServices,
            t,
            columns: tableColumnsOutput,
            listOptionFields: {
              cutOffDOM: 'cutOffDOM',
              orderType: 'types',
              orderStatus: 'statusOrder',
            },
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllItemServices,
          t,
          title: t('reportPage:sidebar.subscriptionBillableServices').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.subscriptionBillableServices')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.subscriptionBillableServices')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('BILLABLE_SERVICES_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportItemServices,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listItemServices,
      emails,
      isOpenModalExportConfig,
      exportColumnsSave,
    } = this.state;
    const {
      listAllItemServices,
      t,
      isFromCustomer,
      permissions: { modeGetBillableService, modeDownloadReport, modeGetMailReport },
      isRenderHeaderForm,
      currencyOptions,
      customerInfo,
      id,
    } = this.props;
    if (!modeGetBillableService) return '';
    let currencyLabel = '';
    if (isRenderHeaderForm && currencyOptions && currencyOptions.length && customerInfo?.currency) {
      const currencySelect = currencyOptions.find(val => val.value === customerInfo?.currency);
      currencyLabel = currencySelect ? currencySelect.normalLabel : '';
    }

    const exportColumns = exportColumnsSave || {};

    tableColumnsOutput = exportColumns?.targetFields?.items || [];

    return (
      <div className="col-md-12">
        {!isFromCustomer && (
          <PageTitle
            linkTo={RouteNames.report.path}
            titleBtn="back"
            items={[
              { name: t('label.report'), url: RouteNames.report.path },
              { name: t('reportPage:sidebar.subscriptionBillableServices') },
            ]}
          />
        )}
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.subscriptionBillableServices')} />
          {isRenderHeaderForm && (
            <AccountHeaderFrom
              accountNum={id}
              commercialName={customerInfo?.commercialName || ''}
              isCommercialName={customerInfo?.customerSegment !== 'B2C'}
              currencyLabel={currencyLabel ? `(${currencyLabel})` : ''}
            />
          )}
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                {isFromCustomer ? (
                  <ItemCustomerServicesSearchForm onSubmit={this.onHandleSubmitSearch} />
                ) : (
                  <ItemServicesSearchForm onSubmit={this.onHandleSubmitSearch} />
                )}
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.subscriptionBillableServices').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllItemServices,
                          t,
                          title: t('reportPage:sidebar.subscriptionBillableServices').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.subscriptionBillableServices')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listItemServices}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput || []}
                  data={listItemServices && listItemServices.length ? listItemServices : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

ItemServices.propTypes = {
  getBillableServicesReport: PropTypes.func,
  getAllBillableServicesReport: PropTypes.func,
  listAllItemServices: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.objectOf(PropTypes.any)]),
};

ItemServices.defaultProps = {
  getBillableServicesReport: () => {},
  getAllBillableServicesReport: () => {},
  listAllItemServices: [],
};

const mapStateToProps = createStructuredSelector({
  listItemServices: makeGetListBillableServices() || [],
  listAllItemServices: makeGetListAllBillableServices() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getBillableServicesReport,
    getAllBillableServicesReport,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
  })(ItemServices)
);
